export default "__VITE_ASSET__11b8f177__"